document.addEventListener('DOMContentLoaded', () => {
  const accordionColumns = document.querySelectorAll('[data-footer-accordion]');

  if (!accordionColumns.length) return;

  accordionColumns.forEach((column) => {
    const toggle = column.querySelector('[data-footer-toggle]');

    if (!toggle) return;

    toggle.addEventListener('click', () => {
      column.classList.toggle('is-open');
    });
  });
});
